import { useMemo } from "react";
import { useSelector } from "react-redux";
import { userSelector } from "../redux/auth/authSelector";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";

export const useUserTimezone = () => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const { user } = useSelector(userSelector);

  const offset = useMemo(
    () => (user?.timezone?.timezone ? dayjs().tz(user.timezone.timezone).utcOffset() : dayjs().utcOffset()),
    [ user?.timezone?.timezone ],
  );

  return { offset };
};
